/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
  useCustomCursor: false,
  googleTrackingID: "",
};

//SEO Related settings
const seo = {
  title: "Saeed Mosaffer",
  description:
    "Portfolio of Saeed Mosaffer — Computer Scientist specializing in Cybersecurity, Full-Stack Development, and AI-powered security systems.",
  og: {
    title: "Saeed Mosaffer | Cybersecurity & Full-Stack Developer",
    type: "website",
    url: "https://github.com/saeedmosaffer",
  },
};

//Home Page
const greeting = {
  title: "Saeed Mosaffer",
  logo_name: "Saeed Mosaffer",
  nickname: "",
  subTitle:
    "Specialist computer scientist with strong experience in cybersecurity and full-stack software development. Passionate about building secure, scalable web applications and defending digital systems through advanced threat detection.",
  resumeLink: "/Saeed_Mosaffer_CV.pdf",
  portfolio_repository: "https://github.com/saeedmosaffer",
  githubProfile: "https://github.com/saeedmosaffer",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  {
    name: "Github",
    link: "https://github.com/saeedmosaffer",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/saeed-mosaffer/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:saeedmosaffer39@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/saeedmosaffer/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/saeed.mosaffer/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Cybersecurity & Penetration Testing",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Expertise in penetration testing, digital forensics, and threat detection",
      ],
      softwareSkills: [
        {
          skillName: "Metasploit",
          fontAwesomeClassname: "simple-icons:metasploit",
          style: {
            color: "#2596CD",
          },
        },
        {
          skillName: "Wireshark",
          fontAwesomeClassname: "simple-icons:wireshark",
          style: {
            color: "#1679A7",
          },
        },
        {
          skillName: "Nmap",
          fontAwesomeClassname: "fa6-solid:magnifying-glass",
          style: {
            color: "#4E9A06",
          },
        },
        {
          skillName: "Burp Suite",
          fontAwesomeClassname: "simple-icons:burpsuite",
          style: {
            color: "#FF6633",
          },
        },
        {
          skillName: "Autopsy",
          fontAwesomeClassname: "fa6-solid:fingerprint",
          style: {
            color: "#2F4F4F",
          },
        },
        {
          skillName: "Acunetix",
          fontAwesomeClassname: "fa6-solid:bug",
          style: {
            color: "#662D91",
          },
        },
        {
          skillName: "Nessus",
          fontAwesomeClassname: "fa6-solid:shield-virus",
          style: {
            color: "#00A98F",
          },
        },
        {
          skillName: "FOCA",
          fontAwesomeClassname: "mdi:shield-search",
          style: {
            color: "#3E64FF",
          },
        },
        {
          skillName: "theHarvester",
          fontAwesomeClassname: "fa6-solid:magnifying-glass-location",
          style: {
            color: "#227C70",
          },
        },
        {
          skillName: "Sublist3r",
          fontAwesomeClassname: "fa6-solid:sitemap",
          style: {
            color: "#8E44AD",
          },
        },
        {
          skillName: "Maltego",
          fontAwesomeClassname: "fa6-solid:diagram-project",
          style: {
            color: "#1F3A93",
          },
        },
        {
          skillName: "Zaproxy",
          fontAwesomeClassname: "simple-icons:owasp",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Kali Linux",
          fontAwesomeClassname: "simple-icons:kalilinux",
          style: {
            color: "#557C94",
          },
        },
        {
          skillName: "Ubuntu",
          fontAwesomeClassname: "simple-icons:ubuntu",
          style: {
            color: "#E95420",
          },
        },
      ],
    },
    {
      title: "Full-Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building secure, scalable web applications with modern frameworks",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon:java",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#777BB4",
          },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "devicon:csharp",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "mdi:database",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "simple-icons:angular",
          style: {
            color: "#DD0031",
          },
        },
        {
          skillName: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
          style: {
            color: "#FF2D20",
          },
        },
        {
          skillName: "ASP.NET",
          fontAwesomeClassname: "simple-icons:dotnet",
          style: {
            color: "#512BD4",
          },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "simple-icons:springboot",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#092E20",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "simple-icons:css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "XML",
          fontAwesomeClassname: "mdi:xml",
          style: {
            color: "#F16529",
          },
        },
        {
          skillName: "JSON",
          fontAwesomeClassname: "simple-icons:json",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "REST APIs",
          fontAwesomeClassname: "mdi:api",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Cloud & DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience deploying and managing cloud-based applications and containerized services",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Microsoft Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#2496ED",
          },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "DigitalOcean",
          fontAwesomeClassname: "simple-icons:digitalocean",
          style: {
            color: "#0080FF",
          },
        },
        {
          skillName: "Cloudflare",
          fontAwesomeClassname: "simple-icons:cloudflare",
          style: {
            color: "#F38020",
          },
        },
        {
          skillName: "Sentry",
          fontAwesomeClassname: "simple-icons:sentry",
          style: {
            color: "#362D59",
          },
        },
        {
          skillName: "UptimeRobot",
          fontAwesomeClassname: "mdi:robot-happy",
          style: {
            color: "#3BD671",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [],
};

const degrees = {
  degrees: [
    {
      title: "Birzeit University",
      subtitle: "Bachelor of Computer Science",
      logo_path: "birzeit_logo.png",
      alt_name: "Birzeit University",
      duration: "Sep 2020 - Feb 2025",
      location: "Ramallah, Palestine",
      descriptions: [],
      website_link: "https://www.birzeit.edu/",
    },
    {
      title: "Ahmad Dahlan University",
      subtitle: "Master of Informatics Engineering — Digital Forensics",
      logo_path: "uad.png",
      alt_name: "Ahmad Dahlan University",
      duration: "Sep 2026 - Present",
      location: "Yogyakarta, Indonesia",
      descriptions: [],
      website_link: "https://uad.ac.id",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "C)SP: Certified Security Principles",
      subtitle: "- Mile2",
      fontAwesomeClassname: "mdi:shield-lock",
      color: "#E53935",
      certificate_link: "",
      alt_name: "Mile2",
      color_code: "#8C151599",
    },
    {
      title: "CompTIA Security+",
      subtitle: "- CompTIA",
      fontAwesomeClassname: "simple-icons:comptia",
      color: "#C8202F",
      certificate_link: "",
      alt_name: "CompTIA",
      color_code: "#E4292499",
    },
    {
      title: "CCNA (Cisco Certified Network Associate)",
      subtitle: "- Cisco",
      fontAwesomeClassname: "simple-icons:cisco",
      color: "#1BA0D7",
      certificate_link: "",
      alt_name: "Cisco",
      color_code: "#1BA0D799",
    },
    {
      title: "Master Back-End Development",
      subtitle: "- Back-End Development",
      fontAwesomeClassname: "mdi:server",
      color: "#43A047",
      certificate_link: "",
      alt_name: "",
      color_code: "#2E86AB99",
    },
    {
      title: "Cybersecurity Intermediate",
      subtitle: "- Cybersecurity Training",
      fontAwesomeClassname: "mdi:security-network",
      color: "#E53935",
      certificate_link: "",
      alt_name: "",
      color_code: "#6C3AB199",
    },
    {
      title: "EF SET English Certificate",
      subtitle: "- EF SET",
      fontAwesomeClassname: "mdi:translate",
      color: "#1565C0",
      certificate_link: "",
      alt_name: "EF SET",
      color_code: "#2ECC7199",
    },
    {
      title: "Machine Learning",
      subtitle: "- Machine Learning",
      fontAwesomeClassname: "simple-icons:tensorflow",
      color: "#FF6F00",
      certificate_link: "",
      alt_name: "",
      color_code: "#F1C40F99",
    },
    {
      title: "Blockchain",
      subtitle: "- Blockchain",
      fontAwesomeClassname: "mdi:link-variant",
      color: "#F9A825",
      certificate_link: "",
      alt_name: "",
      color_code: "#34495E99",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work Experience and Internships",
  description:
    "I have worked across government, cybersecurity, and full-stack development roles, building secure systems and gaining hands-on experience in penetration testing, threat detection, and modern web development.",
  header_image_path: "",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "IT Engineer",
          company: "Palestinian Ministry of Finance",
          company_url: "",
          logo_path: "ministry_logo.jpg",
          duration: "Aug 2025 - Aug 2026",
          location: "Ramallah, Palestine",
          description:
            "Develop and maintain solutions in the ASYCUDA customs system using Java. Design and enhance front-end interfaces for internal tax administration systems using Angular.",
          color: "#0B5345",
        },
        {
          title: "Programming Instructor",
          company: "Women's Center Shu'fat Camp",
          company_url: "",
          logo_path: "shufat_logo.jpg",
          duration: "Apr 2025 - Aug 2025",
          location: "Jerusalem - Palestine",
          description:
            "Delivered programming training sessions at a women's community center in Shu'fat Camp, teaching software development fundamentals to participants with no prior experience.",
          color: "#1F618D",
        },
        {
          title: "Back-End Developer",
          company: "Grids Apps Company",
          company_url: "",
          logo_path: "grids_logo.svg",
          duration: "Dec 2023 - Jun 2024",
          location: "Ramallah, Palestine",
          description:
            "Built and maintained Laravel-based applications, ensuring content updates and modern web practices.",
          color: "#7D3C98",
        },
      ],
    },
    {
      title: "Internship",
      experiences: [
        {
          title: "Cybersecurity & .NET Developer Trainee",
          company: "GSG Company (in collaboration with Purex Company)",
          company_url: "",
          logo_path: "gsg_logo.svg",
          duration: "Oct 2024 - Feb 2025",
          location: "Ramallah, Palestine",
          description:
            "Completed Cybersecurity Intermediate Training covering penetration testing, threat detection, network analysis, and digital forensics. Built applications using .NET and C# as part of agile projects and teamwork.",
          color: "#154360",
        },
        {
          title: "Full Stack Developer",
          company: "IConnect Company",
          company_url: "",
          logo_path: "iconnect_logo.png",
          duration: "Sep 2023 - Oct 2023",
          location: "Ramallah, Palestine",
          description:
            "Developed secure full-stack applications using Angular and ASP.NET.",
          color: "#B9770E",
        },
        {
          title: "Network and Database Trainee",
          company: "Tamkeen Insurance Company",
          company_url: "",
          logo_path: "tamkeen_logo.png",
          duration: "Aug 2023 - Sep 2023",
          location: "Ramallah, Palestine",
          description:
            "Supported network and database operations, contributing to performance optimization and data security.",
          color: "#922B21",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "A selection of my work spanning cybersecurity tooling, full-stack web applications, and AI-powered security systems.",
  avatar_image_path: "",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "",
};

const publications = {
  data: [],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile_photo_white.jpg",
    description:
      "I am available on almost every social media and email. Feel free to reach out — I can help you with Cybersecurity, Full-Stack Development, and AI-powered solutions.",
  },
  blogSection: {
    title: "",
    subtitle: "",
    link: "",
    avatar_image_path: "",
  },
  addressSection: {
    title: "",
    subtitle: "",
    locality: "",
    country: "",
    region: "",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "",
    location_map_link: "",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+972569605357",
  },
};

// My Works Page
const works = {
  title: "My Works",
  subtitle: "Live projects I've built and deployed",
  projects: [
    {
      id: 1,
      title: "CyberX Solutions",
      description:
        "AI-powered cybersecurity SaaS platform for network threat detection and botnet analysis. Built with multi-tenant architecture, advanced machine learning models, and enterprise-grade authentication.",
      logo: require("./assets/images/cyberx_logo.png"),
      liveUrl: "https://cyberxsolutions.co",
      color: "#0A2472",
    },
    {
      id: 2,
      title: "ISHRAQ Academy",
      description:
        "Online learning platform offering high-quality courses in Arabic and English. Built for students of all levels — clear lessons, progress tracking, and certificates upon completion.",
      logo: require("./assets/images/ishraq_logo.jpg"),
      liveUrl: "https://ishraqacademy.com",
      color: "#1a1a2e",
    },
  ],
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  works,
};
